import { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { USER_API } from '../common/common';
import { useSelector } from 'react-redux';
import { postApi, } from '../service';
import { Logout } from '../common/Funcation';
import moment from 'moment';
import Cookies from 'universal-cookie';

function MybetPopup({ open, handlclose }) {
  const navigate = useNavigate()
  const cookies = new Cookies()
  const [mybet, setMybet] = useState(open);
  const [closing, setClosing] = useState(false);
  const [activeType, setActiveType] = useState('exchange');
  const [pageData, setPageData] = useState([])
  const [selectedMatch, setSelectedMatch] = useState()
  const [openBetinfo, setOpenBetinfo] = useState(false)
  const [expandedItems, setExpandedItems] = useState({})
  const isAuthenticated = useSelector((e) => e.isAuthenticated);
  const exchangeRef = useRef(null);
  const parlyRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [allDropDownOption, setAllDropDownOption] = useState([
    'by Time',
    'by Event'
  ])
  const [dropDownOption, setDropDownOption] = useState('by Time')
  const [openDropdown, setOpenDropdown] = useState(false);

  const [tabLine, setTabLine] = useState({
    left: 0,
    width: 0,
  });

  useEffect(() => {
    const activeRef =
      activeType === "exchange" ? exchangeRef : parlyRef;

    if (activeRef.current) {
      setTabLine({
        left: activeRef.current.offsetLeft,
        width: activeRef.current.offsetWidth,
      });
    }
  }, [activeType]);

  useEffect(() => {
    if (cookies.get('skyTokenFront')) {
      // setInterval(() => {
      getPageData()
      // }, 5000);
    }

  }, [])

  useEffect(() => {
    setMybet(open);
    if (open) {
      setClosing(false);
    }
  }, [open]);

  const getPageData = async () => {
    setLoading(true);
    let data = {
      api: USER_API.BET_LIST,
      value: {
      }
    }
    await postApi(data).then(function (response) {
      setPageData(response.data.data)
    }).catch(err => {
      if (err.response.data.statusCode === 401) {
        Logout()
        // navigate('/login')
      }
    }).finally(() => {
      setLoading(false);
    })
  }



  const handleToggleExpand = (item) => {
    setExpandedItems(prev => ({
      ...prev,
      [item._id]: !prev[item._id]
    }))
  }

  const handleClose = () => {
    setClosing(true);
  }

  const handleAnimationEnd = (e) => {
    if (closing && (e.animationName === 'mybetSlideDown' || e.target === e.currentTarget)) {
      setMybet(false);
      setClosing(false);
      handlclose(false);
      setOpenBetinfo(false);
      setSelectedMatch('');
    }
  }

  const handleBetPopup = () => {
    if (isAuthenticated) {
      setMybet(true)
    }
    else {
      window.location.href = '/login'
    }
  }



  return (
    <>
      {
        mybet &&
        <>
          <div
            className={`market-depth-modal mybet ${closing ? 'mybet-exit' : 'mybet-enter'}`}
            style={{ height: "calc(100% - 88px)" }}
            onAnimationEnd={handleAnimationEnd}
          >

            {!openBetinfo ?
              <>
                <div className="market-title">
                  <h4 style={{ fontSize: "13.52px" }}>My Bets</h4>
                  <button type="button"
                    onClick={handleClose}
                    className="border-0 abc text-white position-absolute end-0 top-0 pt-1 fs-4 bg-transparent border-0 btn btn-primary" z style={{ cursor: "pointer" }}>
                    <svg stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 15 15" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z" fill="currentColor"></path>
                    </svg>
                  </button>
                </div>

                <div className='mybet_tab' style={{ position: "relative", gap: "10px" }} >
                  <div
                    className="mybet_tab_line"
                    style={{
                      width: `${tabLine.width}px`,
                      transform: `translateX(${tabLine.left}px)`,
                      position: "absolute",
                      bottom: "3px",
                      left: 0,
                      height: "3px",
                      background: "#000",
                      transition: "transform 0.3s ease, width 0.3s ease",
                      pointerEvents: "none",
                      padding: 0
                    }}
                  />
                  <div ref={exchangeRef}
                    // className={`${activeType === 'exchange' ? 'active' : ''}`} 
                    onClick={() => setActiveType('exchange')} style={{ fontSize: "13.52px", paddingBottom: "4px" }}>Exchange <span className="bg-dark text-white d-inline-block" style={{ fontSize: "10.4px", marginLeft: "2px", borderRadius: "0.25rem" }} >{pageData?.length || 0}</span></div>
                  <div ref={parlyRef}
                    // className={`${activeType === 'parly' ? 'active' : ''}`} 
                    onClick={() => setActiveType('parly')} style={{ fontSize: "13.52px", paddingBottom: "4px" }} > Parly < span className="bg-dark text-white d-inline-block" style={{ fontSize: "10.4px", marginLeft: "2px", borderRadius: "0.25rem" }} >0</span></div>
                </div>
                <div className="all-complete">
                  <div className="dropdown">
                    <button type="button" id="abc" aria-expanded="false" style={{ minWidth: "118px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.0588235294)", padding: "2px 4px" }} className={`dropdown-toggle btn btn-primary ${openDropdown ? 'active' : ''}`} onClick={() => setOpenDropdown(!openDropdown)}>
                      <div>
                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" className="me-1" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7 20h2V8h3L8 4 4 8h3zm13-4h-3V4h-2v12h-3l4 4z"></path>
                        </svg>
                        {/* by Competition */}
                        {dropDownOption}
                      </div>
                    </button>
                    {openDropdown &&
                      <div x-placement="bottom-start" aria-labelledby="abc" style={{ boxShadow: "0 2px 4px rgba(0, 0, 0, 0.0588235294)" }} className="dropdown-menu" data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="bottom-start"
                      // style="position: absolute; inset: 0px auto auto 0px; transform: translate3d(0px, 40.5px, 0px);"
                      >
                        {allDropDownOption.map(((_option) => {
                          return (
                            <a data-rr-ui-dropdown-item="" className="dropdown-item" role="button" onClick={() => { setDropDownOption(_option); setOpenDropdown(false) }}>{_option}</a>
                          )
                        }))}
                        {/* <a data-rr-ui-dropdown-item="" className="dropdown-item" role="button" >by Time</a>
                                <a data-rr-ui-dropdown-item="" className="dropdown-item" role="button" >by Matched</a> */}
                      </div>
                    }
                  </div>

                  <div style={{ padding: "0.5rem", cursor: "pointer", background: "#fff", fontSize: "11.44px", borderRadius: "6px", display: "flex", justifyContent: "center", alignItems: "center", height: "27px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.0588235294)" }}>
                    <span className="mr-1" >ALL</span>
                    <svg stroke="currentColor" style={{ rotate: "180deg" }} fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                      <path fill="none" d="M0 0h24v24H0z"></path>
                      <path d="M6 17.59L7.41 19 12 14.42 16.59 19 18 17.59l-6-6z"></path>
                      <path d="M6 11l1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z"></path>
                    </svg>
                  </div>
                </div>


                <div className="market-depth-body" style={{ height: "calc(100% - 127.32px)", padding: "0.5rem 0.25rem", overflowY: "scroll", scrollbarWidth: "none", msOverflowStyle: "none", WebkitScrollbarDisplay: "none" }}>
                  <style>{`
                    .expandable-content {
                      animation: slideDown 0.3s ease;
                    }
                    @keyframes slideDown {
                      from {
                        opacity: 0;
                        max-height: 0;
                        overflow: hidden;
                      }
                      to {
                        opacity: 1;
                        max-height: 500px;
                        overflow: visible;
                      }
                    }
                  `}</style>
                  <ol className="p-0 m-0">

                    {pageData && pageData?.map((item, i) => {
                      return (
                        <>
                          <li className="d-flex align-items-center justify-content-between" style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem", paddingLeft: "0.5rem", paddingRight: "0.5rem", borderBottom: "1px solid #d4e0e5" }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <span className="bg-yellow fw-bold" style={{ fontSize: "10.4px", width: "21.84px", height: "18.2px", borderRadius: "3.64px", textAlign: "center" }}>
                                {item.betPlaced}
                              </span>
                              <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", fontSize: "13.52px", lineHeight: 1.2, paddingLeft: "6px" }}>
                                <span className="master-pass first" style={{ paddingLeft: 0 }}>{item.matchId.name}</span>
                                <svg stroke="#d4e0e5" fill="#d4e0e5" strokeWidth="0" viewBox="0 0 24 24" className="arrow-icon" style={{ margin: "0px 3px" }} height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z"></path>
                                </svg>
                                <span className="master-pass" style={{ fontWeight: 400, textTransform: "capitalize", paddingLeft: 0 }}>{item.betType}</span>
                              </div>
                            </div>
                            <button type="button" className="right-angel px-2 btn btn-primary" style={{ background: "#d4e0e5", border: "none" }} onClick={() => handleToggleExpand(item)}>
                              <svg
                                stroke="currentColor"
                                fill="currentColor"
                                strokeWidth="0"
                                viewBox="0 0 256 512"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  transform: expandedItems[item._id] ? 'rotate(270deg)' : 'rotate(90deg)',
                                  transition: 'transform 0.3s ease'
                                }}
                              >
                                <path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path>
                              </svg>
                            </button>
                          </li>
                          {expandedItems[item._id] && (
                            <li className="expandable-content">
                              <div style={{ borderRadius: "4px", margin: "0.2rem .5rem", background: "#f8f9fa", border: "1px solid #d4e0e5" }}>
                                <table className="rounded overflow-hidden bg-white mb-0 odds-table table" style={{ border: "1px solid #d4e0e5", fontSize: "13.52px" }}>
                                  <tbody>
                                    <tr className="lay-back">
                                      <td colSpan={3} style={{ fontWeight: 700, background: "#eef6fb", borderBottom: "1px solid #d4e0e5" }}> <span className={`bet-name ${item.betSide === 'back' ? 'back' : 'lay'}`} style={{ fontSize: "13.52px", padding: "4px 10px", textTransform: "capitalize" }}>{item.betSide} </span> {item.selection} </td>
                                    </tr>
                                    <tr>
                                      <style>
                                        {`
                                          td.table-data-header {
                                            font-size: 10.4px !important;
                                          }
                                        `}
                                      </style>
                                      <td className='table-data-header' style={{ borderRight: "1px solid #d4e0e5" }}>Odds req. <strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.oddsUp.toFixed(2)}</strong></td>
                                      <td className='table-data-header' style={{ borderRight: "1px solid #d4e0e5" }}>Stake (PBU) <strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.stake.toFixed(2)}</strong></td>
                                      <td className='table-data-header'>Liability (PBU)<strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.profit?.toFixed(2)}</strong></td>
                                    </tr>
                                    <tr style={{ fontSize: "13.52px" }}>
                                      <td className="" colSpan={3} style={{ borderTop: "1px solid #d4e0e5" }}>
                                        <div className="d-flex justify-content-between" style={{ fontSize: "10.4px", color: "#6c757d" }}>Ref: {item._id}<span>{moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}</span></div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </li>
                          )}
                        </>
                      )
                    })}
                  </ol>
                </div>

              </>




              :

              <>
                <div className="market-title">
                  <button className="bg-transparent border-0 text-white position-absolute start-0 pt-0" onClick={() => setOpenBetinfo(false)}>
                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 256 512" className="fs-3" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                      <path d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path>
                    </svg>
                  </button>
                  <div className='match_title_popup'>
                    <span className="">{selectedMatch[0].winnerSelection[0]} vs {selectedMatch[0].winnerSelection[1]}</span>
                    <br />
                    <span className="master-pass">{selectedMatch[0].betType}</span>
                  </div>
                  <button type="button"
                    onClick={handleClose}
                    className="border-0 abc text-white position-absolute end-0 top-0 pt-1 fs-4 bg-transparent border-0 btn btn-primary">
                    <svg stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 15 15" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z" fill="currentColor"></path>
                    </svg>
                  </button>
                </div>

                <div className="market-depth-body" >
                  <div>
                    <h5 className="text-center bg-darklight mb-0 py-2 fs-5">
                      <div className="match-border-sec active" style={{ fontSize: "13.52px" }}>Matched <span className="bg-dark text-white px-1 d-inline-block rounded" style={{ fontSize: "10.4px" }}> {selectedMatch.length} </span></div>
                    </h5>
                    <div className="current-bets-table p-2 border-0 single-match-body">

                      {selectedMatch.map((item, i) => {
                        return (
                          <table className="rounded overflow-hidden bg-white mb-3 odds-table table table-bordered" key={i}>
                            <tbody>


                              <tr className="lay-back">
                                <td colSpan={3}> <span className={`bet-name ${item.betSide === 'back' ? 'back' : 'lay'}`}>{item.betSide} </span> {item.selection} </td>
                              </tr>
                              <tr>
                                <td>Odds. <strong className="d-block"> {item.oddsUp} </strong></td>
                                <td>Stake (PBU) <strong className="d-block"> {item.stake} </strong></td>
                                <td>Profit (PBU)<strong className="d-block"> {item.profit} </strong></td>
                              </tr>
                              <tr>
                                <td className="" colSpan={3}>
                                  <div className="d-flex justify-content-between">Ref: {item._id}<span>{moment(item.createdAt).format('DD-MM-YYYY hh:mm A')}</span></div>
                                </td>
                              </tr>


                            </tbody>
                          </table>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </>
            }



          </div>
          <div className={`overlay ${closing ? 'overlay-exit' : 'overlay-enter'}`} onClick={handleClose}></div>
        </>
      }

    </>



  )
}

export default MybetPopup